/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Epal: no free shipping when the cart holds húsgögn (custom.shipping_class == 'husgogn').
  // snippets/cart-price.liquid emits <span data-cart-shipping-flags data-cart-has-husgogn>
  // and is re-rendered on every AJAX cart change; hide/show every free-shipping bar accordingly.
  const syncFreeShippingForHusgogn = () => {
    const flags = document.querySelector('[data-cart-shipping-flags]')
    if (!flags) return
    const hasHusgogn = flags.getAttribute('data-cart-has-husgogn') === 'true'
    document.querySelectorAll('[data-free-shipping]').forEach(el => {
      el.style.display = hasHusgogn ? 'none' : ''
    })
  }
  document.addEventListener('theme:cart:change', syncFreeShippingForHusgogn)

  // ── Epal search (2026-09-06, reworked 2026-10-06): Icelandic inflections for Shopify's search ──
  // Shopify's own search (keyword + semantic) copes with English ("mug" finds Bolli) and with most single words, but
  // next to a brand an inflected word is ignored: "vasa moomin" returned every Moomin product and no vase. So a word
  // that is an INFLECTED form of a noun in assets/epal-synonyms.js (generated by .claude/data/gen_search_synonyms.py)
  // becomes "(typed OR lemma OR 2nd form)": "vasa moomin" → "(vasa OR vasi OR vasar) moomin". Sent as typed: words
  // already in dictionary form, words after a preposition ("bolli með loki": the lid describes the cup), and every
  // word not in the file (product names, brands, English). The expansion is only KEPT when Shopify still fills a
  // page (10 products from /search/suggest.json): a query of OR-groups alone switches Shopify to strict word
  // matching ("(lampar OR lampi)" found 5 products), and then plain is better.
  // Measured 2026-10-06 on 55 queries, mean precision@10: this rule 0.91, plain Shopify 0.84, and the old rule (every
  // known word → 9 terms: English, compounds, extras) 0.84; the old rule wrecked product names ("bolli kaleo" lost
  // Bolli KALEO, "tripp trapp púði" lost every Tripp Trapp cushion). Applied in three places:
  //   1. the <predictive-search> web component (patched getSearchResults) → live dropdown
  //   2. any search form submit → navigates to the decided query, the typed words kept in ?orig=
  //   3. the results page → inputs / caption show the typed words, not the expansion
  const EpalSearch = (() => {
    const fold = (s) => s.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/ð/g, 'd').replace(/þ/g, 'th').replace(/æ/g, 'ae').replace(/ø/g, 'o').replace(/ß/g, 'ss')
    const trim = (w) => w.replace(/^[^\p{L}\p{N}]+|[^\p{L}\p{N}]+$/gu, '')
    // folded prepositions: með, m/, fyrir, f/, án, úr, í, á, til, frá, undir, yfir, við, um
    const PREP = new Set(['med', 'm', 'fyrir', 'f', 'an', 'ur', 'i', 'a', 'til', 'fra', 'undir', 'yfir', 'vid', 'um'])
    let index = null
    const build = () => {
      index = new Map()
      const forms = (window.EpalSynonyms && window.EpalSynonyms.forms) || []
      forms.forEach((f) => f.forEach((t) => { const k = fold(t); if (!index.has(k)) index.set(k, f) }))
    }
    // the expanded query, or null when no word in q is an inflected form we know
    const candidate = (q) => {
      q = (q || '').trim()
      if (!q || /[()":*]|\b(AND|OR|NOT)\b/.test(q)) return null   // already an expression → leave alone
      if (!index || !index.size) build()
      const tokens = q.split(/\s+/)
      let changed = false
      const out = tokens.map((tok, i) => {
        const clean = trim(tok)
        const f = clean && index.get(fold(clean))
        if (!f || fold(f[0]) === fold(clean) || (i > 0 && PREP.has(fold(trim(tokens[i - 1]))))) return tok
        changed = true
        return '(' + [...new Set([clean, f[0], f[1]].filter(Boolean))].join(' OR ') + ')'
      })
      return changed ? out.join(' ') : null
    }
    // typed → query to send, remembered per tab so the results page reuses the dropdown's decision
    const memo = new Map()
    const KEY = 'epalSearch:'
    const remembered = (q) => {
      if (memo.has(q)) return memo.get(q)
      try { const v = sessionStorage.getItem(KEY + q); if (v !== null) { memo.set(q, v); return v } } catch (e) {}
      return undefined
    }
    const remember = (q, v) => { memo.set(q, v); try { sessionStorage.setItem(KEY + q, v) } catch (e) {} }
    const decide = (q) => {
      q = (q || '').trim()
      const cand = candidate(q)
      if (!cand) return Promise.resolve(q)
      const known = remembered(q)
      if (known !== undefined) return Promise.resolve(known)
      const base = (window.theme && theme.routes && theme.routes.predictive_search_url) || '/search/suggest'
      return fetch(`${base}.json?q=${encodeURIComponent(cand)}&resources[type]=product&resources[limit]=10`)
        .then((r) => (r.ok ? r.json() : null))
        .then((d) => {
          if (!d) return q                                // request failed: plain this time, decide again next time
          const products = (d.resources && d.resources.results && d.resources.results.products) || []
          const v = products.length >= 10 ? cand : q
          remember(q, v)
          return v
        })
        .catch(() => q)
    }
    return { candidate, decide, remembered, fold }
  })()
  window.EpalSearch = EpalSearch

  // 1. predictive search: fetch with the decided query, keep the typed words in "Leita að …"
  if (window.customElements) {
    customElements.whenDefined('predictive-search').then(() => {
      const P = customElements.get('predictive-search')
      const origGet = P.prototype.getSearchResults
      const origRender = P.prototype.renderSearchResults
      P.prototype.getSearchResults = function (term) {
        this.epalTyped = term
        return EpalSearch.decide(term).then((q) => {
          if (this.epalTyped !== term) return          // a newer keystroke took over
          this.epalExpanded = q
          return origGet.call(this, q)
        })
      }
      // keep the results panel inside the viewport (it is wider than the search box)
      const origOpen = P.prototype.open
      P.prototype.open = function () {
        origOpen.call(this)
        const panel = this.predictiveSearchResults
        if (!panel || !panel.classList.contains('search-epal__results')) return
        const vw = document.documentElement.clientWidth
        const box = this.input.form.getBoundingClientRect()
        if (vw < 750) {                                // mobile: span the whole viewport
          panel.style.left = `${Math.round(-box.left)}px`
          panel.style.width = `${vw}px`
          return
        }
        const width = Math.min(900, vw - 32)
        let left = 0                                   // relative to the box's left edge
        if (box.left + width > vw - 16) left = (vw - 16 - width) - box.left
        panel.style.left = `${Math.round(left)}px`
      }
      P.prototype.renderSearchResults = function (markup) {
        origRender.call(this, markup)
        if (!this.epalExpanded || this.epalExpanded === this.epalTyped) return
        this.querySelectorAll('[data-predictive-search-search-for-text], [data-predictive-search-live-region-count-value]').forEach((el) => {
          el.textContent = el.textContent.split(this.epalExpanded).join(this.epalTyped)
        })
      }
    })
  }

  // 2. search form submit → go to the decided query (bubbling phase: after the theme's own handlers, skip if prevented).
  //    Navigates itself instead of writing the expansion into the field, so the customer never sees "(skálar OR skál)"
  //    in the search bar (it flashed there until the results page loaded). ?orig= carries the typed words, and is also
  //    sent when plain won: it marks the query as decided.
  document.addEventListener('submit', (e) => {
    const form = e.target
    if (e.defaultPrevented || !(form instanceof HTMLFormElement) || (form.method || 'get').toLowerCase() !== 'get') return
    const action = (form.getAttribute('action') || '').split('?')[0]
    if (!/\/search\/?$/.test(action)) return
    const q = form.querySelector('input[name="q"]')
    if (!q) return
    const typed = q.value.trim()
    // An exact brand name goes to the brand page (2026-10-08). The dropdown marks its brand row with the term it was
    // rendered for, so a row left over from an earlier word is never followed; without it the results page redirects
    // (layout/theme.liquid + snippets/epal-brand-for-term.liquid), so this only saves that hop.
    const handle = EpalSearch.fold(typed).replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '')
    const brand = handle && document.querySelector(`[data-epal-brand-term="${handle}"][data-epal-brand-url]`)
    if (brand && handle !== 'bad') {
      e.preventDefault()
      window.location.assign(brand.getAttribute('data-epal-brand-url'))
      return
    }
    if (!EpalSearch.candidate(typed)) return
    e.preventDefault()
    const go = (query) => {
      const params = new URLSearchParams(new FormData(form))
      params.set('q', query)
      params.set('orig', typed)
      window.location.assign(form.action.split('?')[0] + '?' + params.toString())
    }
    const known = EpalSearch.remembered(typed)   // usually decided already by the dropdown while typing
    if (known !== undefined) go(known)
    else EpalSearch.decide(typed).then(go)       // one small request first
  })

  // 0. results page reached WITHOUT the form (a bookmark, a link, the address bar, Google), or through a link saved
  //    under the old 9-term rule (its q is neither the typed words nor today's expansion): decide now and redirect
  //    once to the same URL as the form would send it. Every other parameter (type, filters, sort, page) is kept.
  if (/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?search\/?$/i.test(location.pathname)) {
    const params = new URLSearchParams(location.search)
    const q0 = (params.get('q') || '').trim()
    const orig = params.get('orig')
    const typed = (orig || q0).trim()
    const stale = orig && q0 !== typed && q0 !== EpalSearch.candidate(typed)
    if (typed && (orig ? stale : EpalSearch.candidate(typed) !== null)) {
      EpalSearch.decide(typed).then((query) => {
        if (query === q0) return
        params.set('q', query)
        params.set('orig', typed)
        if (!params.has('options[prefix]')) params.set('options[prefix]', 'last')
        location.replace(location.pathname + '?' + params.toString() + location.hash)
      })
    }
  }

  // 3. results page: show the typed words instead of the expansion
  const restoreTypedTerm = () => {
    const params = new URLSearchParams(location.search)
    const q = params.get('q'), orig = params.get('orig')
    if (!q || !orig || q === orig) return
    // visible fields only: the filter form's hidden q must keep the expansion (layout/theme.liquid does the same while parsing)
    document.querySelectorAll('input[name="q"]:not([type="hidden"])').forEach((i) => { if (i.value === q) i.value = orig })
    document.querySelectorAll('.search__caption, [data-results-count], .search__title').forEach((el) => {
      if (el.textContent.includes(q)) el.textContent = el.textContent.split(q).join(orig)
    })
    if (document.title.includes(q)) document.title = document.title.split(q).join(orig)
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', restoreTypedTerm)
  else restoreTypedTerm()

  document.addEventListener('theme:product:added', syncFreeShippingForHusgogn)
  document.addEventListener('DOMContentLoaded', syncFreeShippingForHusgogn)
  syncFreeShippingForHusgogn()

  const validateEmail = (email) => {
    const re = /\S+@\S+\.\S+/
    return re.test(email)
  }

  window.addEventListener('theme:variant:change', e => {
    const { target, detail: { variant }} = e

    if (!target.hasAttribute('data-quick-add-modal')) return;
    if (!target.querySelector('.js-email-input')) return;

    target.querySelector('.product-form').classList.remove('has-success')

    target.querySelector('.js-email-input')?.classList[variant.available ? 'add': 'remove']('hidden')
    target.querySelector('.js-atc-btn')?.classList[variant.available ? 'remove': 'add']('hidden')
    target.querySelector('.js-subscribe-btn')?.classList[variant.available ? 'add': 'remove']('hidden')

    if (variant.available) {
      target.querySelector('.js-email-input').setAttribute('disabled', '')
    } else {
      target.querySelector('.js-email-input').removeAttribute('disabled')
    }
  })
  document.addEventListener('click', e => {
    const button = e.target.closest('.js-subscribe-btn')
    if (!button) return;
    e.preventDefault();

    const form = e.target.closest('form')
    const emailInput = form.querySelector('.js-email-input')
    const formData = new FormData(form)
    const id = formData.get('id')
    const email = formData.get('email')
    const emailError = form.querySelector('.email-error');
    const msg = document.querySelector('.product__notification__message')

    for(var pair of formData.entries()){
      console.log(pair[0], pair[1]);
    }
    emailInput.classList.remove('error')
    emailError.style.display = 'none'
    msg.style.display = 'none'


    if (!validateEmail(email)) {
      emailInput.classList.add('error')
      emailError.style.display = 'block'
      return
    }

    button.classList.add('is-loading');

    const payload = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email
              }
            }
          },
          channels: [
            'EMAIL'
          ]
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: `$shopify:::$default:::${id}`
            }
          }
        }
      }
    }

    fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=${ window.theme.settings.klaviyoCompanyId }`, {
      method: 'POST',
      headers: {
        accept: 'application/vnd.api+json',
        revision: '2024-10-15',
        'content-type': 'application/vnd.api+json'
      },
      body: JSON.stringify(payload)
    }).then(res => res.text())
    .then(() => {
      emailInput.value = ''
      form.classList.add('has-success')
      msg.style.display = 'block'

    })
    .catch(err => console.error(err))
    .finally(() => {
      button.classList.remove('is-loading');

      setTimeout(() => {
        form.classList.remove('has-success')
        msg.style.display = 'none'
      }, 3000)
    });
  })

  const formId = 'VKtmNV'; 
  const formIdSignedOut = 'zyt2kG'
  const formConsent = document.querySelector('form[data-cf-form="' + formId + '"]') || document.querySelector('form[data-cf-form="' + formIdSignedOut + '"]')
  document.addEventListener('cf:ready', function() {
    if (!Boolean(formConsent)) return;
    const innerPanel = document.querySelector('.loyalty-panel__inner__content')
    const guestText = document.querySelector('.loyalty-points-guest')

    formConsent.addEventListener('cf:form_submitted', function(event) {
      innerPanel.classList.add('hidden')
      guestText.classList.add('hidden')
    })
})
  /* Button update for new-product start */
    function updateCustomATCDisplay(variant, qty) {
      let price = 0
      const plus_btn = document.querySelector('.custom-atc-plus');
      const minus_btn = document.querySelector('.custom-atc-minus');
      if(variant){
        if (variant.available){
          const sub_check = document.getElementById('activate-subscription')?.checked;
          document.querySelector('.js-atc-btn').classList.remove('hidden');
          if(sub_check == true){
            plus_btn.style.display = 'none';
            minus_btn.style.display = 'none';
          }else{
            plus_btn.style.display = 'flex';
            minus_btn.style.display = 'flex';
          }
        }else{
          plus_btn.style.display = 'none';
          minus_btn.style.display = 'none';
        }
      }
      if (!variant){
        let price_text = document.querySelector('.custom-atc-total').getAttribute('data-price');
        let price_Float = parseFloat(price_text);
        price =  price_Float.toFixed(2);
      }else{
        price = variant.price / 100;
      }
      document.querySelector('.custom-atc-total').textContent = price ? (price * qty).toFixed(2) : '0.00';
      document.querySelectorAll('.custom-atc-qty').forEach(el => el.textContent = qty);
      const qtyInput = document.querySelector('input.custom-atc-qty');
      if (qtyInput) qtyInput.value = qty;
      const plus = document.querySelector('.custom-atc-plus');
      if (plus) {
        if (qty >= 10) {
          plus.classList.add('disabled');
          plus.setAttribute('aria-disabled', 'true');
        } else {
          plus.classList.remove('disabled');
          plus.removeAttribute('aria-disabled');
        }
      }
      if(minus_btn){
        if (qty == 1) {
          minus_btn.classList.add('disabled');
          minus_btn.setAttribute('aria-disabled', 'true');
          document.querySelector('.atc-main-wrap').classList.remove('has_more');
        } else {
          minus_btn.classList.remove('disabled');
          minus_btn.removeAttribute('aria-disabled');
        }
      }
    }
let customATCListenersAttached = false;
    function attachCustomATCListeners() {
        if (customATCListenersAttached) return; // already attached
        customATCListenersAttached = true;
      let qty = 1;
      let currentVariant = window?.Shopify?.currentVariant || null;

      const minus = document.querySelector('.custom-atc-minus');
      const plus = document.querySelector('.custom-atc-plus');
      if (!minus || !plus) return;

      minus.addEventListener('click', function(e) {
        qty = document.querySelector('input.custom-atc-qty').value;
        e.preventDefault();
        if (qty > 1) {
          qty--;
          updateCustomATCDisplay(currentVariant, qty);
        }
         if (qty == 1) {
          document.querySelector('.atc-main-wrap').classList.remove('has_more');
        }
      });

      plus.addEventListener('click', function(e) {
        qty = document.querySelector('input.custom-atc-qty').value;
        e.preventDefault();
        if (qty < 10) {
          qty++;
          updateCustomATCDisplay(currentVariant, qty);
          document.querySelector('.atc-main-wrap').classList.add('has_more');
        }
      });

      document.addEventListener('theme:variant:change', function(e) {
        if (!e.detail || !e.detail.variant) return;
        currentVariant = e.detail.variant;
        qty = 1;
        updateCustomATCDisplay(currentVariant, qty);
      });

      // Initial update
      if (currentVariant) updateCustomATCDisplay(currentVariant, qty);
    }

    document.addEventListener('DOMContentLoaded', function() {
       if (!document.body.classList.contains('template--new-product')) return;
      attachCustomATCListeners();
    });
    document.addEventListener("theme:cart:change", function(e) {
      if (!document.body.classList.contains('template--new-product')) return;
        const aty_qty = document.querySelectorAll('.custom-atc-qty');
        if(aty_qty.length > 0 ){
          aty_qty.forEach(el => el.textContent = 1);
          document.querySelector('input.custom-atc-qty').value = 1; 
          const sub_check = document.getElementById('activate-subscription') ? document.getElementById('activate-subscription').checked : false;
          if(sub_check == false){
            const priceText = document.querySelector('.product__price [data-product-price]').textContent;
            const single_price = parseFloat(priceText.replace(/[^\d.]/g, '')).toFixed(2);
            document.querySelector('.custom-atc-total').textContent = single_price;
            const plus_btn = document.querySelector('.custom-atc-plus');
            const minus_btn = document.querySelector('.custom-atc-minus');
            minus_btn.classList.add('disabled');
            plus_btn.classList.remove('disabled');
            document.querySelector('.atc-main-wrap').classList.remove('has_more');
          }
          attachCustomATCListeners();
        }
    });
    document.getElementById('activate-subscription')?.addEventListener('change', function(event) {
      if (!document.body.classList.contains('template--new-product')) return;
      const plus_btn = document.querySelector('.custom-atc-plus');
      const minus_btn = document.querySelector('.custom-atc-minus');
      const has_subscription = document.querySelector('.custom-atc-label.has-subscription');
      const no_subscription = document.querySelector('.custom-atc-label:not(.has-subscription)');
      if(event.target.checked == true){
        plus_btn.style.display = 'none';
        minus_btn.style.display = 'none';
        no_subscription.style.display = 'none';
        has_subscription.style.display = 'block';
      }else{
        plus_btn.style.display = 'flex';
        minus_btn.style.display = 'flex';
        has_subscription.style.display = "none";
        no_subscription.style.display = "block";
        const aty_qty = document.querySelectorAll('.custom-atc-qty');
        if(aty_qty.length > 0 ){
          aty_qty.forEach(el => el.textContent = 1);
        }
        const priceText = document.querySelector('.product__price [data-product-price]').textContent;
        const single_price = parseFloat(priceText.replace(/[^\d.]/g, '')).toFixed(2);
        document.querySelector('.custom-atc-total').textContent = single_price;
        document.querySelector('.custom-atc-total').setAttribute('data-price',single_price)
        minus_btn.classList.add('disabled');
        minus_btn.setAttribute('aria-disabled', 'true');
        plus_btn.classList.remove('disabled');
        plus_btn.removeAttribute('aria-disabled');
        document.querySelector('.atc-main-wrap').classList.remove('has_more');
      }
      document.querySelector('input.custom-atc-qty').value = 1; 
      attachCustomATCListeners();
    });

  /* Button update for new-product end */

  // ── Epal colour dots on grid cards (2026-09-10) ──
  // snippets/product-grid-item.liquid renders <a data-epal-swatch data-variant-title="…"> dots and,
  // inside the card image, one hidden <div data-variant-title="…"> per variant that has its own
  // image (Broadcast's own markup). Hovering a dot shows that image; leaving the card resets it.
  // Taps just follow the link to the product page with the variant selected.
  (function () {
    var visible = 'is-visible';
    function reset(item) {
      item.querySelectorAll('[data-product-image] [data-variant-title].' + visible).forEach(function (el) {
        el.classList.remove(visible);
      });
    }
    document.addEventListener('mouseover', function (e) {
      var dot = e.target.closest ? e.target.closest('[data-epal-swatch]') : null;
      if (!dot) return;
      var item = dot.closest('[data-grid-item]');
      if (!item) return;
      var title = dot.getAttribute('data-variant-title');
      var found = false;
      item.querySelectorAll('[data-product-image] [data-variant-title]').forEach(function (el) {
        var hit = el.getAttribute('data-variant-title') === title;
        el.classList.toggle(visible, hit);
        if (hit) found = true;
      });
      if (!found) reset(item);
    });
    document.addEventListener('mouseout', function (e) {
      var item = e.target.closest ? e.target.closest('[data-grid-item]') : null;
      if (!item || item.contains(e.relatedTarget)) return;
      reset(item);
    });
  })();

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.

})();


document.addEventListener('DOMContentLoaded', () => {
  const mobileMenu = document.querySelector('#header-menu')
  if (!mobileMenu) return
  const accordionItems = mobileMenu.querySelectorAll('.accordion-item')

  accordionItems.forEach(accordionItem => {
    accordionItem.addEventListener('click', e => {
      if(e.target.classList.contains('accordion-item-link')) return
      e.preventDefault()
      e.stopPropagation();
      e.stopImmediatePropagation();

      accordionItem.classList.toggle('is-open')
    })
    })




// document.addEventListener("theme:cart:change", ()=> didcountNinjaCall() )

})

const moneyFormat = "${{amount}}"

/**
 * Format money values based on your shop currency settings
 * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
 * or 3.00 dollars
 * @param  {String} format - shop money_format setting
 * @return {String} value - formatted value
 */
function formatMoney(cents, format) {
  if (typeof cents === "string") {
    cents = cents.replace(".", "")
  }
  let value = ""
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/
  const formatString = format || moneyFormat

  function formatWithDelimiters(number, precision = 2, thousands = ",", decimal = ".") {
    if (isNaN(number) || number == null) {
      return 0
    }

    number = (number / 100.0).toFixed(precision)

    const parts = number.split(".")
    const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`)
    const centsAmount = parts[1] ? decimal + parts[1] : ""

    return dollarsAmount + centsAmount
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2)
      break
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0)
      break
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",")
      break
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",")
      break
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".")
      break
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ", "")
      break
    case "amount_with_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ",")
      break
    case "amount_with_period_and_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ".")
      break
  }

  return formatString.replace(placeholderRegex, value)
}





(function() {
  const backCartBtn = document.querySelector('.cart__button-continue .btn');
  if(!Boolean(backCartBtn)) return
  const continueShoppingText = document.querySelector('.continue-shopping-text');
  const backButtonText = document.querySelectorAll('.back-shopping-text');
  const lastPageUrl = document.referrer;
  let url = sessionStorage.getItem("lastVisitedUrl");
  console.log(Boolean(url))

  if(Boolean(lastPageUrl)) {
    sessionStorage.setItem("lastVisitedUrl", lastPageUrl);
    url = sessionStorage.getItem("lastVisitedUrl");
  }

  if(Boolean(url)) {
    backCartBtn.href=url
    backButtonText.forEach(btn => {
      btn.style.display = 'flex'
    })
    continueShoppingText.style.display = 'none';

  } else {
    continueShoppingText.style.display = 'block';
    backButtonText.forEach(btn => {
      btn.style.display = 'none'
    })
  }

})();

// Epal (2026-09-11): early feedback for the online-quantity cap (max(custom.online_qty, max
// custom.orderable_by_location), Worker-written). The validation Function no longer runs at the
// CART step: Shopify validates the whole resulting cart on every mutation, so a cart-step error
// deadlocked the cart once stock drifted (removing any OTHER item was refused, silently). The
// checkout step is the hard stop; this only (1) clamps a typed drawer quantity to the line's `max`
// (cart-line-items.liquid) and (2) stops quick-add on grids from adding past the cap.
// (leading `;`: the IIFE above ends without one, so `(function` was parsed as a call on it.)
;(function () {
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || !input.matches || !input.matches('input.cart__quantity-field[max]')) return;
    var max = parseInt(input.max, 10), val = parseInt(input.value, 10);
    if (isNaN(max) || isNaN(val) || val <= max) return;
    input.value = max;
  }, true);

  var counts = {};
  function refreshCounts() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var next = {};
        (cart.items || []).forEach(function (i) { next[i.variant_id] = (next[i.variant_id] || 0) + i.quantity; });
        counts = next;
      })
      .catch(function () {});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refreshCounts); else refreshCounts();
  document.addEventListener('theme:cart:change', refreshCounts);
  document.addEventListener('theme:product:add', refreshCounts);

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('quick-add-product [data-add-to-cart][data-epal-cap]');
    if (!btn) return;
    var form = btn.form || document.getElementById(btn.getAttribute('form'));
    var idInput = form && form.querySelector('input[name="id"]');
    var cap = parseInt(btn.getAttribute('data-epal-cap'), 10);
    if (!idInput || isNaN(cap)) return;
    var inCart = counts[idInput.value] || 0;
    if (inCart < cap) return;
    e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
    var holder = btn.closest('[data-quick-add-holder]');
    var msg = cap === 1
      ? 'Aðeins 1 eintak er fáanlegt á vefnum og það er þegar í körfunni.'
      : 'Aðeins ' + cap + ' eintök eru fáanleg á vefnum og þau eru þegar í körfunni.';
    if (holder) holder.dispatchEvent(new CustomEvent('theme:cart:error', { bubbles: true, detail: { message: msg, description: msg, holder: holder } }));
  }, true);
})();

/* Predictive-search panel (2026-09-14): the panel is positioned inside the search form, so a 100vw panel
   (phones, where the form sits ~76px from the left edge) or a 900px panel (narrow desktops) stuck out past
   the screen and made the whole page scroll sideways. Measure the form and set the panel's offset/width via
   CSS vars (see .search-epal__results in custom.css): phones = full width from x=0, desktop = 900px, slid left
   so it never runs past the right edge minus 16px. */
;(function () {
  var MOBILE = 749, MAX = 900, GUTTER = 16
  function place() {
    var forms = document.querySelectorAll('form.search-epal')
    if (!forms.length) return
    var vw = document.documentElement.clientWidth
    forms.forEach(function (form) {
      // the panel is absolute inside the form's padding box: border-box left + border width
      var left = form.getBoundingClientRect().left + form.clientLeft
      if (vw <= MOBILE) {
        form.style.setProperty('--epal-search-shift', (-left) + 'px')
        form.style.setProperty('--epal-search-w', vw + 'px')
      } else {
        // keep the full panel width; slide it left when it would run past the right gutter
        var w = Math.max(280, Math.min(MAX, vw - 2 * GUTTER))
        var shift = Math.min(0, (vw - GUTTER) - (left + w))
        form.style.setProperty('--epal-search-shift', shift + 'px')
        form.style.setProperty('--epal-search-w', w + 'px')
      }
    })
  }
  var t
  function schedule() { clearTimeout(t); t = setTimeout(place, 50) }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', place); else place()
  window.addEventListener('load', place)
  window.addEventListener('resize', schedule)
  window.addEventListener('orientationchange', schedule)
  document.addEventListener('focusin', function (e) { if (e.target && e.target.closest && e.target.closest('form.search-epal')) place() })
})();

;(function () {
  // PDP main-image sale badge (.epal-sale-corner) follows the selected variant.
  window.addEventListener('theme:variant:change', function (e) {
    var variant = e.detail && e.detail.variant
    var el = e.target && e.target.querySelector && e.target.querySelector('[data-epal-sale-corner]')
    if (!variant || !el) return
    var off = variant.compare_at_price > variant.price ? Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price) : 0
    el.textContent = '-' + off + '%'
    el.hidden = off < 1
  })
})();

;(function () {
  // Mega menu column offset: the first column of a column-style mega menu (.grandparent--columns)
  // starts under the first top-level nav item. The nav's left edge moves with the number of menu
  // items and the viewport, so measure it and hand it to custom.css as --epal-mega-pad.
  function measure() {
    var item = document.querySelector('.menu__item.grandparent--columns')
    if (!item || !item.offsetParent) return
    var first = document.querySelector('.menu__item [data-top-link] .navtext')
    var wrap = item.querySelector('.header__dropdown__wrapper')
    if (!first || !wrap) return
    var pad = first.getBoundingClientRect().left - wrap.getBoundingClientRect().left - parseFloat(getComputedStyle(wrap).paddingLeft)
    if (pad > 0 && pad < 400) document.documentElement.style.setProperty('--epal-mega-pad', Math.round(pad) + 'px')
  }
  var t
  window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(measure, 150) })
  if (document.readyState === 'complete') measure(); else window.addEventListener('load', measure)
  document.addEventListener('DOMContentLoaded', measure)
})();

/* Price filter (designer 2026-09-25, page 3,3 "tölur sem sjást"): the Verð inputs are type=number, which the range slider
   and the filter URL need as plain digits, so the formatted value (1.589.000) is drawn by a span laid over each input
   (snippets/filters.liquid, styles in epal-collection.css). The slider writes input.value without an event, so the spans
   follow its data-se-*-value attributes; AJAX filter re-renders are caught by the same observer. The input text is only
   hidden once this has run (.is-epal-formatted), so without JS the plain number still shows. */
;(function () {
  if (!/template-(collection|search)/.test(document.body.className)) return
  function fmt(v) {
    var n = parseFloat(v)
    if (isNaN(n)) return ''
    return String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, '.')
  }
  function sync() {
    document.querySelectorAll('[data-epal-price-display]').forEach(function (span) {
      var field = span.parentElement
      var input = field && field.querySelector('input')
      if (!input) return
      var text = fmt(input.value !== '' ? input.value : input.placeholder)
      if (span.textContent !== text) span.textContent = text
      field.classList.add('is-epal-formatted')
    })
    // One font size per pair: the largest (14px down to 11px) at which both numbers fit their box. The desktop
    // column leaves ~74px a box, too narrow for 1.663.000 at 14px; the phone drawer is wider and keeps 14px.
    document.querySelectorAll('.filter__price__fields').forEach(function (pair) {
      var spans = pair.querySelectorAll('[data-epal-price-display]')
      if (!spans.length || !spans[0].clientWidth) return
      for (var px = 14; px >= 11; px--) {
        pair.style.setProperty('--epal-price-size', px + 'px')
        var fits = true
        spans.forEach(function (sp) { if (sp.scrollWidth > sp.clientWidth) fits = false })
        if (fits) break
      }
    })
  }
  var queued = false
  function queue() {
    if (queued) return
    queued = true
    requestAnimationFrame(function () { queued = false; sync() })
  }
  document.addEventListener('input', queue, true)
  document.addEventListener('change', queue, true)
  // a collapsed group or hidden sidebar has no width to measure: size again when it opens
  document.addEventListener('toggle', queue, true)
  document.addEventListener('transitionend', queue, true)
  window.addEventListener('resize', queue)
  new MutationObserver(queue).observe(document.body, {
    subtree: true, childList: true, attributes: true, attributeFilter: ['data-se-min-value', 'data-se-max-value']
  })
  sync()
})();

// Cart drawer "Halda áfram að versla" (2026-10-06, staff request): closes the drawer. Broadcast binds only the X
// (querySelector) and re-renders the drawer body on every cart change, so the click is delegated.
;(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-epal-continue-shopping]')
    if (!btn) return
    e.preventDefault()
    var drawer = btn.closest('cart-drawer')
    if (drawer && typeof drawer.closeCartDrawer === 'function') drawer.closeCartDrawer()
    else {
      var x = drawer && drawer.querySelector('[data-cart-drawer-close]')
      if (x) x.click()
    }
  })
})();

// Remove an applied discount code with the X in the cart drawer / cart page (2026-10-19, Ingibjörg: an Epal gift card
// stayed on the cart after its items were removed and could not be X-ed out). The gift card block (LOYALTY BLOCK in
// sections/cart-drawer.liquid) turns the card into a Shopify discount code ON THE CART, and Broadcast only wires the X
// (snippets/cart-price.liquid, data-remove-discount) when its own discount-code block is in the drawer, which ours is
// not. Only codes are removed (an automatic discount has no code, the X then does nothing). TO REVERSE: delete this
// block. OPEN: whether claiming already took the amount off the card (LAUNCH-REVIEW).
;(function () {
  function handle(s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '') }
  var busy = false
  document.addEventListener('click', function (e) {
    var x = e.target.closest('[data-remove-discount]')
    if (!x) return
    if (document.querySelector('[data-apply-discount]')) return // Broadcast's discount block is present: it handles the X
    e.preventDefault()
    if (busy) return
    var body = x.closest('[data-discount-code]')
    var target = body && body.getAttribute('data-discount-code')
    if (!target) return
    busy = true
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json() })
      .then(function (cart) {
        var codes = (cart.discount_codes || []).map(function (d) { return d.code })
        var keep = codes.filter(function (c) { return handle(c) !== target })
        if (keep.length === codes.length) return
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ discount: keep.join(',') })
        }).then(function () { document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true })) })
      })
      .catch(function (err) { console.error('Remove discount failed', err) })
      .then(function () { busy = false })
  })
})();
